import {
  FacebookIntegrationView,
  GitHubInstallationRequestView,
  GitHubIntegrationView,
  GoogleIntegrationStatus,
  InstagramIntegrationView,
  MicrosoftIntegrationStatus,
  SlackTeamIntegrationView,
  SlackUserIntegrationView,
  WhatsAppIntegrationView,
} from '@this+that/models';
import { StateCreator } from 'zustand';

import {
  handleClearTeamScopedIntegrations,
  handleIsEmailAccountRemoved,
  handleMarkEmailAccountRemoved,
  handleRemoveIntegrationAccount,
  handleResetStore,
  handleSetCurrentEmailFilters,
  handleSetCurrentIntegrationAccount,
  handleSetIntegrationAccounts,
  handleSetIsDraftSaving,
  handleSetLoading,
  handleSetTeamFacebookIntegrations,
  handleSetTeamGithubInstallationRequests,
  handleSetTeamGithubIntegrations,
  handleSetTeamInstagramIntegrations,
  handleSetTeamSlackBotIntegrations,
  handleSetUserGoogleIntegrations,
  handleSetUserMicrosoftIntegrations,
  handleSetUserSlackIntegrations,
  handleSetUserWhatsAppIntegrations,
} from './handlers';
import { IntegrationsStore } from './types';
import { IntegrationAccount } from '../../../../../web/src/models/integrationAccount';

export const createIntegrationsSlice: StateCreator<IntegrationsStore> = (
  set,
  get,
) => {
  return {
    isLoading: true,
    integrationAccounts: [],
    currentIntegrationAccount: null,
    userSlackIntegrations: [],
    teamSlackBotIntegrations: [],
    userMicrosoftIntegrations: [],
    userWhatsAppIntegrations: [],
    teamInstagramIntegrations: [],
    teamFacebookIntegrations: [],
    teamGithubIntegrations: [],
    teamGithubInstallationRequests: [],
    userGoogleIntegrations: [],
    isDraftSaving: false,
    currentEmailFilters: undefined,
    removedEmailAccounts: {},
    setIntegrationAccounts: (accounts: IntegrationAccount[]) =>
      handleSetIntegrationAccounts(set, accounts),
    setLoading: (isLoading) => handleSetLoading(set, isLoading),
    setCurrentIntegrationAccount: (integrationAccount) =>
      handleSetCurrentIntegrationAccount(set, integrationAccount),
    removeIntegrationAccount: (integrationAccount) =>
      handleRemoveIntegrationAccount(set, integrationAccount),
    setUserSlackIntegrations: (integrations: SlackUserIntegrationView[]) =>
      handleSetUserSlackIntegrations(set, integrations),
    setTeamSlackBotIntegrations: (integrations: SlackTeamIntegrationView[]) =>
      handleSetTeamSlackBotIntegrations(set, integrations),
    setUserMicrosoftIntegrations: (
      integrations: MicrosoftIntegrationStatus[],
    ) => handleSetUserMicrosoftIntegrations(set, integrations),
    setUserWhatsAppIntegrations: (integrations: WhatsAppIntegrationView[]) =>
      handleSetUserWhatsAppIntegrations(set, integrations),
    setTeamInstagramIntegrations: (integrations: InstagramIntegrationView[]) =>
      handleSetTeamInstagramIntegrations(set, integrations),
    setTeamFacebookIntegrations: (integrations: FacebookIntegrationView[]) =>
      handleSetTeamFacebookIntegrations(set, integrations),
    setTeamGithubIntegrations: (integrations: GitHubIntegrationView[]) =>
      handleSetTeamGithubIntegrations(set, integrations),
    setTeamGithubInstallationRequests: (
      requests: GitHubInstallationRequestView[],
    ) => handleSetTeamGithubInstallationRequests(set, requests),
    setUserGoogleIntegrations: (integrations: GoogleIntegrationStatus[]) =>
      handleSetUserGoogleIntegrations(set, integrations),
    setIsDraftSaving: (isDraftSaving) =>
      handleSetIsDraftSaving(set, isDraftSaving),
    setCurrentEmailFilters: (filters) =>
      handleSetCurrentEmailFilters(set, filters),
    markEmailAccountRemoved: (platform, address) =>
      handleMarkEmailAccountRemoved(set, platform, address),
    isEmailAccountRemoved: (platform, address) =>
      handleIsEmailAccountRemoved(get, platform, address),
    clearTeamScopedIntegrations: () => handleClearTeamScopedIntegrations(set),
    resetStore: () => handleResetStore(set),
  };
};
